import { debounce } from 'lodash';
export const camelToSnakeCase = (str) => str.replace(/[A-Z]/gu, (letter) => `_${letter.toLowerCase()}`);
export const camelToSpaced = (str) => str.replace(/[A-Z]/gu, (letter) => ` ${letter.toLowerCase()}`);
export const spacedToSnakeCase = (str) => str.replace(/\s[a-zA-Z]/gu, (letter) => `_${letter.toLowerCase().trim()}`);
export const spacedToCapitalized = (str) => str.replace(/^[a-zA-Z]|\s[a-zA-Z]/gu, (letter) => letter.toUpperCase());
export const snakeToSpaced = (str) => str.replace(/^[a-zA-Z]|_[a-zA-Z]/gu, (letter) => letter.replace('_', ' '));
export const camelToSnakeCaseObject = (obj) => {
    const res = {};
    for (const key in obj) {
        res[camelToSnakeCase(key)] = obj[key];
    }
    return res;
};
export const isPOJO = (obj) => {
    return (Boolean(obj) &&
        typeof obj === 'object' &&
        Object.getPrototypeOf(obj) === Object.prototype);
};
export const flattenObject = (obj, propertyNameTransformer = (name) => name, delimiter = '_') => {
    if (!isPOJO(obj)) {
        return obj;
    }
    const flatObj = {};
    for (const propertyName in obj) {
        const newPropertyName = propertyNameTransformer(propertyName);
        if (isPOJO(obj[propertyName])) {
            const nested = flattenObject(obj[propertyName], propertyNameTransformer, delimiter);
            for (const nestedPropertyName in nested) {
                flatObj[newPropertyName + delimiter + nestedPropertyName] =
                    nested[nestedPropertyName];
            }
        }
        else {
            flatObj[newPropertyName] = obj[propertyName];
        }
    }
    return flatObj;
};
export const debounceAsync = (func, timeout) => {
    const debounced = debounce((resolve, reject, args) => {
        func(...args)
            .then(resolve)
            .catch(reject);
    }, timeout);
    return async (...args) => new Promise((resolve, reject) => {
        debounced(resolve, reject, args);
    });
};
export const formatObjectValues = (object, formatter) => {
    const formatted = {};
    for (const [key, value] of Object.entries(object)) {
        formatted[key] = formatter(value);
    }
    return formatted;
};
